import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { PrintTemplateInterface } from '../../+models';
import { PrintTemplatesActions, PrintTemplatesActionTypes } from './print-template.actions';

export const NAME = 'printTemplates';

export interface State extends EntityState<PrintTemplateInterface> {
  // additional entities state properties
  loaded: boolean;
  error?: any;
}

export const adapter: EntityAdapter<PrintTemplateInterface> = createEntityAdapter<PrintTemplateInterface>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
  loaded: false,
});

export function reducer(state = initialState, action: PrintTemplatesActions): State {
  switch (action.type) {
    case PrintTemplatesActionTypes.PrintTemplatesLoaded: {
      return adapter.setAll(action.payload.printTemplates, {
        ...state,
        loaded: true,
      });
    }

    case PrintTemplatesActionTypes.PrintTemplatesLoadError: {
      return { ...state, error: action.payload, loaded: false };
    }

    default: {
      return state;
    }
  }
}

export const { selectIds, selectEntities, selectAll, selectTotal } = adapter.getSelectors();
